import { computedFrom } from "aurelia-binding";
import { BaseMepResponse } from "./mep.models";

// Requests
export interface BaseMepSummaryRequest {
    year: number;
    portIds: number[];
    vesselTypeGroupIds: number[];
    operationModeIds: number[];
    emissionTypeIds: number[];
    scopeIds: number[];

    // Optional
    cargoTypeIds?: number[];
    monthNumbers?: number[];
    pointOfInterestIds?: number[];
}

export interface MepPortSummaryTotalEmissionsRequest extends BaseMepSummaryRequest{
}

export interface MepGetEmissionsByPortsRequest extends BaseMepSummaryRequest {
}

export interface MepGetSummaryVesselStatisticsRequest {
    year: number;
    lastYear: number;
    portIds: number[];
    vesselTypeGroupIds: number[];
    operationModeIds: number[];
    emissionTypeIds: number[];
    scopeIds: number[];
}

// Responses
export interface MepPortSummaryTotalEmissionsResponse extends BaseMepResponse {
    totalEmissionsByTypes: TotalEmissionsByTypeModel[];
    totalEmissionsByScopes: TotalEmissionsByScopeModel[];
}

export interface TotalEmissionsByScopeModel {
    scopeId: number;
    emissionTypeCategoryId: number;
    weightedEmissionValue: number;
}

export interface TotalEmissionsByTypeModel {
    emissionsTypeId: number;
    emissionsTypeName: string;
    emissionsTypeFullName: string;
    totalEmissionsQtyTonnes: number;
    targetEmissionsQtyTonnes: number;
    colourCode: number;
    displayOrder: number;
    weightingFactor: number;
    emissionTypeCategoryId: number;
}

export interface MepGetEmissionsByPortsResponse extends BaseMepResponse {
    emissionsByPort: MepEmissionsByPort[];
}

export interface MepEmissionsByPort {
    portId: number;
    portName: string;
    totalWeightedEmissionsinTonnes: number;
    emissionTypeCategoryId: number;
}

export interface MepPortSummaryVesselsByPortRequest {
    portIds: number[];
    vesselTypeGroupIds: number[];
    operationModeIds: number[];
    emissionTypeIds: number[];
    year: number;
    monthNumbers: number[];
    scopeIds: number[];
}

export interface MepPortSummaryVesselsByPortResponse extends BaseMepResponse {
    vesselByPorts: VesselByPortModel[];
}

export interface VesselByPortModel {
    portId: number;
    portName: string;
    vesselCalls: number;
    tugJobs: number;
}

export interface MepGetSummaryVesselStatisticsResponse {
    summaryVesselStatistics: MepSummaryVesselStatistics;
    vesselCallsPercentage: number;
    vesselCountPercentage: number;
    tugboatJobsPercentage: number;
}

export interface MepSummaryVesselStatistics {
    vesselCount: MepGetVesselCount;
    vesselCallsAndTugboatJobs: MepGetVesselCallsAndTugboatJobs;
}

export interface MepGetVesselCount {
    year: number;
    vesselCount: number;
    totalVesselCount: number;
}

export interface MepGetVesselCallsAndTugboatJobs {
    year: number;
    vesselCalls: number;
    totalVesselCalls: number;
    tugboatJobs: number;
    totalTugboatJobs: number;
}

export class SummaryVesselStatisticsUIModel {
    name: SummaryVesselStatisticsNames;
    percentage: number;
    totalValue: number;

    constructor(name: SummaryVesselStatisticsNames, totalValue: number, percentage: number) {
        this.name = name;
        this.percentage = percentage;
        this.totalValue = totalValue;
    }

    @computedFrom("name")
    get icon() {
        switch (this.name) {
            case SummaryVesselStatisticsNames.VesselCalls:
                return "anchor";
            case SummaryVesselStatisticsNames.VesselCount:
                return "ship";
            case SummaryVesselStatisticsNames.TugboatJobs:
                return "tugboat";
        }
    }

    @computedFrom("percentage")
    get absPercentage() {
        if (this.percentage == null)
            return this.percentage;

        return Math.abs(this.percentage);
    }
}

export enum SummaryVesselStatisticsNames {
    VesselCalls = "Vessel Calls",
    VesselCount = "Distinct Vessel Count",
    TugboatJobs = "Tugboat Jobs"
}

export interface MepPortSummaryEmissionRequest {
    portIds: number[];
    pointOfInterestIds: number[];
    vesselTypeGroupIds: number[];
    operationModeIds: number[];
    emissionTypeId: number;
    year: number;
    monthNumbers: number[];
    cargoTypeIds: number[];
    scopeIds: number[];
}

export interface MepPortSummaryEmissionResponse extends BaseMepResponse {
    emissionValueInTonnes: number;
}